import * as React from "react";
import { PasswordInput, Label } from "@aisquare/ui";
import { Section, VariantBlock } from "../lib/Section";

export function PasswordInputDemo() {
  // Drive the `valid` affordance from a live value so the success check is
  // visible on a real transition (≥8 chars here stands in for a rule set).
  const [pw, setPw] = React.useState("");

  return (
    <Section
      id="password-input"
      title="PasswordInput"
      description="Password field with a built-in reveal/hide toggle. Composes the base Input (inherits variants, sizes, tokens, focus-ring) and adds an accessible toggle (aria-pressed, kept out of the Tab order) plus an optional success check. The reusable atom login / signup / reset compose."
    >
      <VariantBlock label="Default" caption="click the eye to reveal">
        <div className="grid w-72 gap-1.5">
          <Label htmlFor="pw-default">Password</Label>
          <PasswordInput id="pw-default" autoComplete="current-password" />
        </div>
      </VariantBlock>

      <VariantBlock label="Live validity" caption="check appears once the value passes (≥8 chars)">
        <div className="grid w-72 gap-1.5">
          <Label htmlFor="pw-valid">New password</Label>
          <PasswordInput
            id="pw-valid"
            value={pw}
            onValueChange={setPw}
            valid={pw.length >= 8}
            autoComplete="new-password"
          />
        </div>
      </VariantBlock>

      <VariantBlock label="States">
        <div className="grid w-72 gap-3">
          <PasswordInput aria-label="No toggle" showToggle={false} defaultValue="no-toggle" />
          <PasswordInput aria-label="Disabled" disabled defaultValue="locked" />
          <PasswordInput aria-label="Large" size="lg" placeholder="Large" />
        </div>
      </VariantBlock>
    </Section>
  );
}
